import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, ref, Ref, shallowRef } from 'vue';
import { useRouter } from 'vue-router';
import { AlertModalInjection, LoadingModalInjection } from '@/infra/constants/injections';
import { useTwoFactorAuthStore } from '@/stores/two_factor_auth/two_factor_auth_store';
import NavigatorController from '@/components/NavigatorController.vue';
import AlertModal from '@/components/modals/AlertModal.vue';
import LoadingModal from '@/components/modals/LoadingModal.vue';
import CodeTwoFactorContent from '@/components/two_factor_auth/CodeTwoFactorContent.vue';
import QRCodeTwoFactorContent from '@/components/two_factor_auth/QRCodeTwoFactorContent.vue';
import WelcomeTwoFactorContent from '@/components/two_factor_auth/WelcomeTwoFactorContent.vue';
import { AdminUser } from '@/models/admins/admin_model';
import PersonalInformationContent from '../two_factor_auth/PersonalInformationContent.vue';
import CommonModal from './CommonModal.vue';

enum Pages {
  Welcome = 1,
  QRCode = 2,
  Code = 3,
  Personal = 4
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TwoFactorAuthModal',
  setup(__props, { expose: __expose }) {

const twoFactorAuthStore = useTwoFactorAuthStore();
const router = useRouter();
const user = ref<AdminUser | null>(null);

const commonModal = ref<InstanceType<typeof CommonModal>>();
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);
const alertModal = inject<Ref<InstanceType<typeof AlertModal>>>(AlertModalInjection);

const currentPage = ref(1);
const zIndexRef = ref<number>(2);
const promise = ref<Promise<any>>();
const resolve = ref<(value: any) => void>();
const redirectTo = ref<string | null>(null);
const onCancel = ref<(() => void) | null>();
let components = ref({});

__expose({
  open: open,
  close: closeButton,
});

async function open<T>(params: {
  zIndex?: number,
  whenSubmitRedirectTo?: string,
  user: AdminUser,
  code?: string,
  isInitial?: boolean,
  onCancel?: () => void,
}) {
  if (!params.user?.getHasTwoFactorKey()) {
    currentPage.value = Pages.Welcome;
    components.value = {
      [Pages.Welcome]: shallowRef(WelcomeTwoFactorContent),
      [Pages.QRCode]: shallowRef(QRCodeTwoFactorContent),
      [Pages.Code]: shallowRef(CodeTwoFactorContent),
      [Pages.Personal]: shallowRef(PersonalInformationContent),
    }
  }
  else {
    currentPage.value = Pages.Code;
    components.value = {
      [Pages.Welcome]: shallowRef(WelcomeTwoFactorContent),
      [Pages.QRCode]: shallowRef(QRCodeTwoFactorContent),
      [Pages.Code]: shallowRef(CodeTwoFactorContent),
    }
  }
  onCancel.value = params.onCancel ?? null;
  redirectTo.value = params.whenSubmitRedirectTo ?? null;
  user.value = params.user;
  commonModal.value?.open({
    zIndex: params.zIndex ?? 2,
  });
  zIndexRef.value = params?.zIndex ?? 2;
  promise.value = new Promise<T>((res) => resolve.value = res);
  return await promise.value;
}

async function closeButton<T>(value?: T) {
  commonModal.value?.close();
  resolve.value?.call(null, value);
}

async function submit() {
  if(redirectTo.value) await router.push({ name: redirectTo.value })
  closeButton();
}

function handleCodeInput(value: string) {
  twoFactorAuthStore.setCode(value);
}

async function initialize(enable?: boolean) {
  try {
    loadingModal?.value?.open({ zIndex: (zIndexRef.value + 1) } );
    const res = await twoFactorAuthStore.initialize({ enable });
    if (res.isError()) alertModal?.value?.open({ zIndex: (zIndexRef.value + 1), title: 'Erro', content: res.getError() ?? 'Erro desconhecido' });
    else currentPage.value = currentPage.value + 1;
  } finally {
    loadingModal?.value?.close();
  }
}

function backButton() {
  const isFirstPage = (currentPage.value == Pages.Code && user.value?.getHasTwoFactorKey()) || currentPage.value == Pages.Welcome;
  if (isFirstPage) {
    if (onCancel.value) onCancel.value?.call(null);
    else closeButton();
    return;
  }
  currentPage.value = currentPage.value - 1;
}


const __returned__ = { Pages, twoFactorAuthStore, router, user, commonModal, loadingModal, alertModal, currentPage, zIndexRef, promise, resolve, redirectTo, onCancel, get components() { return components }, set components(v) { components = v }, open, closeButton, submit, handleCodeInput, initialize, backButton, CommonModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})